import * as React from "react";
import { useCallback } from "react";
import usePermissions from "hooks/usePermissions";
import { useTestNotification, useTriggerSecurityEventNotification } from "security-app/hooks/useSecurityEventsAPI";
import StepActionButton from "./StepActionButton";
function StepSendNotification({ step, eventId = void 0 }) {
  const { notification_id } = step.action.config;
  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`eventnotifications:edit:${notification_id}`);
  const { triggerSecurityEventNotification, triggeringSecurityEventNotification } = useTriggerSecurityEventNotification();
  const { testNotification, testingNotification } = useTestNotification();
  const onClick = useCallback(() => {
    if (eventId) {
      triggerSecurityEventNotification({ id: eventId, notificationId: notification_id, stepId: step.id });
    } else {
      testNotification({ id: notification_id });
    }
  }, [eventId, triggerSecurityEventNotification, notification_id, step.id, testNotification]);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? "You don't have access to execute this notification" : void 0,
      title: eventId ? "Send Notification" : "Test Notification",
      onClick: disabled ? null : onClick,
      disabled: disabled || triggeringSecurityEventNotification || testingNotification
    }
  );
}
export default StepSendNotification;
